import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityIncidentLog } from '@api/data-security';

export const getCoreDataSecurityIncidentLogSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityIncidentLog',
	receive: true,
	request: true,
	requestHandler: getDataSecurityIncidentLog,
	retainDataOnRequest: true
});
